import { Context } from "Context";
import { useContext, useEffect, useState } from "react";
import Loading from "./Loading";
import useFetch from "hooks/useFetch";
import appConfig from "config.json";
import { filterContentByUserType } from "utils/filterContent";

const { content, brands } = appConfig;
const cacheMinutes = 5;
const mainClass = "syndicated-footer-wrapper";

const FooterWrapper = ({ children }) => {
	const {
		config: { brand, legal, footer, theme, store, locale },
		footerData,
		legalFooterData,
		setConfig,
		setFooterData,
		setLegalFooterData,
		profileData: { userType, user },
	} = useContext(Context);
	const [footerWrapperUrl, setFooterWrapperUrl] = useState("");
	const { response, error } = useFetch(
		footerWrapperUrl,
		{},
		cacheMinutes,
		footerWrapperUrl
	);
	const brandConfig = brands?.[brand];

	let classes = `${mainClass} ${mainClass}--${brand} ${mainClass}--${locale}`;

	if (theme) {
		classes += ` syndicated-theme--${theme}`;
	}

	if (legal && !footer) {
		classes += ` ${mainClass}--legal`;
	}

	if (store) {
		classes += ` ${mainClass}__store ${mainClass}__store--${store}`;
	}

	useEffect(() => {
		const isUserTypeRequired = brandConfig?.isUserTypeRequiredForContentRequest;
		if (!isUserTypeRequired || (isUserTypeRequired && userType)) {
			const footerBaseUrl =
				legal && !footer ? content.apiUrl.legal : content.apiUrl.footer;
			setFooterWrapperUrl(
				isUserTypeRequired && userType
					? `${footerBaseUrl}?userType=${userType}`
					: footerBaseUrl
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userType, brand, footer, legal]);

	useEffect(() => {
		if (response) {
			let dataResponse = response;

			if (brandConfig?.filterContentKeys) {
				dataResponse = filterContentByUserType(
					response,
					brandConfig.filterContentKeys,
					user
				);
			}

			if (legal && !footer) {
				setLegalFooterData(dataResponse);
			} else {
				setFooterData(dataResponse);
			}
			setConfig((config) => ({ ...config, ...(response.context || {}) }));
		} else if (error) {
			setFooterData({ error: true, loading: false });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [error, response]);

	useEffect(() => {
		if (brandConfig?.filterContentKeys && response) {
			const filteredResponse = filterContentByUserType(
				response,
				brandConfig.filterContentKeys,
				user
			);
			if (legal && !footer) {
				setLegalFooterData(filteredResponse);
			} else {
				setFooterData(filteredResponse);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user?.swid, user?.membership]);

	return (
		<footer role="contentinfo" className={classes}>
			{footerData.loading && legalFooterData.loading && <Loading />}
			{((!footerData.loading && !footerData.error) ||
				(!legalFooterData.loading && !legalFooterData.error)) && (
				<div className="syndicated-footer-wrapper__container">{children}</div>
			)}
		</footer>
	);
};

export default FooterWrapper;
